import React, {useEffect, useContext, useState} from 'react';
import {Tabs} from 'antd';
import {EyeOutlined, CodeOutlined} from '@ant-design/icons';
import {set} from 'lodash';
import {OpenApiContext} from '../../openapi-context';
import {TechnicalEditor} from '../technical-editor';
import {Block} from '../block';
import {ContactBlock} from './contact-block';

export function ContactView({dispatch}) {
    const [contactData, setContactData] = useState();
    const openapi = useContext(OpenApiContext);

    useEffect(() => {
        if (openapi.state.contact) {
            const state = {};
            set(state, 'contact', openapi.state.contact());
            setContactData(state);
        }
    }, [openapi.state]);

    function onSave(contactValue) {
        if (contactValue) {
            dispatch({type: 'update-contact', contact: {name: 'contact', value: contactValue}});
        }
    }

    function onTechnicalEdit(newData) {
        dispatch({type: 'update-contact', contact: {name: 'contact', value: newData.contact}});
    }

    return contactData ? (
        <div className="frontpage">
            <Tabs
                type="card"
                tabPlacement="right"
                id="modelTabs"
                items={[
                    {
                        key: 'visual',
                        label: <EyeOutlined />,
                        children: (
                            <div className="scrollableViewer">
                                <ContactBlock contactData={contactData} onSave={onSave} />
                            </div>
                        ),
                    },
                    {
                        key: 'technical',
                        label: <CodeOutlined />,
                        disabled: openapi.state.editMode,
                        children: (
                            <Block noEdit>
                                <TechnicalEditor object={contactData} update={onTechnicalEdit} />
                            </Block>
                        ),
                    },
                ]}
            />
        </div>
    ) : null;
}
